<section class="pbw-panel">
  <h2 class="pbs-title">Elige la hoja de pagos</h2>
  <p class="pbs-lead">Leerla no registra nada: si algo viene mal, corriges el archivo y lo vuelves a subir.</p>

  <div class="pbs-layout-help">
    <p class="pbs-layout-t">El archivo tiene que traer estas columnas, con este nombre exacto:</p>
    <ul>
      <li><strong>RFC</strong> — el del cliente. Está en la columna RFC del listado de Clientes.</li>
      <li><strong>Cuenta de Deposito</strong> — el nombre de la cuenta donde entró el dinero.</li>
      <li><strong>Monto</strong> — lo que el cliente depositó.</li>
      <li><strong>Forma de Pago</strong> — Deposito, Transferencia, Efectivo, Cheque o Spei.</li>
      <li><strong>Clave de Rastreo</strong> — la del depósito.</li>
      <li><strong>Fecha de Pago</strong> — el día en que el cliente pagó, no el de hoy.</li>
    </ul>
    <p class="pbs-layout-warn">
      Si guardaste un layout viejo (el que pedía la columna <strong>Cliente</strong> con el ID), vuelve a descargarlo:
      ahora el cliente se identifica con su RFC.
    </p>
  </div>

  <!-- Elegir el archivo YA lo lee: no hay un «Leer archivo» que pulsar después. Leerlo no registra
       nada, así que no había nada que confirmar en ese clic. -->
  <div class="pbs-drop">
    <label for="pbwFileInput" class="pbs-file-btn" [class.is-off]="reading">
      <i class="fa-solid" [ngClass]="reading ? 'fa-spinner fa-spin' : 'fa-upload'" aria-hidden="true"></i>
      <span>{{ file ? file.name : 'Seleccionar archivo' }}</span>
      <input type="file" id="pbwFileInput" accept=".xlsx,.csv" [disabled]="reading" (change)="onFileSelected($event)" hidden />
    </label>
    <span class="pbs-hint" *ngIf="reading">Leyendo la hoja…</span>
    <span class="pbs-hint" *ngIf="!reading && !file">Formato .xlsx o .csv, hasta 2 MB.</span>
    <span class="pbs-hint" *ngIf="!reading && file">{{ (file.size / 1024) | number: '1.0-0' }} KB · elige otra hoja para volver a leerla</span>
  </div>

  <div class="pbs-error" *ngIf="error">
    <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
    <span>{{ error }}</span>
  </div>

  <!-- Sin acción de avance: el paso avanza solo al elegir la hoja. Queda la salida y el apoyo. -->
  <div class="pbs-actions">
    <button pButton type="button" label="Salir" class="p-button-text p-button-secondary pbs-left" [disabled]="reading" (click)="onExit.emit()"></button>
    <button pButton type="button" label="Descargar layout" icon="fa-solid fa-download" class="p-button-outlined" [loading]="downloading" (click)="descargarLayout()"></button>
  </div>
</section>
